export const STAGES = [
  ["new_lead", "New Lead", "Nuevo lead"],
  ["contacted", "Contacted", "Contactado"],
  ["appointment_scheduled", "Inspection Scheduled", "Inspección programada"],
  ["estimate_needed", "Estimate Needed", "Presupuesto pendiente"],
  ["estimate_sent", "Estimate Sent", "Presupuesto enviado"],
  ["waiting_customer", "Follow-up", "Seguimiento"],
  ["approved", "Approved", "Aprobado"],
  ["contract_pending", "Contract Pending", "Contrato pendiente"],
  ["contract_signed", "Contract Signed", "Contrato firmado"],
  ["deposit_received", "Deposit Received", "Depósito recibido"],
  ["scheduled", "Scheduled", "Programado"],
  ["in_progress", "In Progress", "En progreso"],
  ["completed", "Completed", "Terminado"],
  ["paid_in_full", "Paid in Full", "Pago completo"],
  ["warranty", "Warranty", "Garantía"],
  ["closed_lost", "Closed / Lost", "Cerrado / Perdido"],
];
export const LEAD_SOURCES = ["Google", "Google Ads", "Website", "Facebook", "Instagram", "Nextdoor", "Referral", "ChatGPT", "Repeat Customer", "API", "Other"];
export const APPT_TYPES = [
  ["estimate", "Estimate", "Presupuesto"],
  ["inspection", "Inspection", "Inspección"],
  ["project_start", "Project Start", "Inicio de proyecto"],
  ["project_work", "Project Work", "Trabajo de proyecto"],
  ["final_walkthrough", "Final Walkthrough", "Revisión final"],
  ["warranty_visit", "Warranty Visit", "Visita de garantía"],
  ["other", "Other", "Otro"],
];
export const APPT_STATUSES = [
  ["scheduled", "Scheduled", "Programada"],
  ["confirmed", "Confirmed", "Confirmada"],
  ["completed", "Completed", "Completada"],
  ["cancelled", "Cancelled", "Cancelada"],
  ["no_show", "No Show", "No se presentó"],
];
export const PROJECT_STATUSES = [
  ["scheduled", "Scheduled", "Programado"],
  ["in_progress", "In Progress", "En progreso"],
  ["waiting", "Waiting", "En espera"],
  ["needs_attention", "Needs Attention", "Requiere atención"],
  ["completed", "Completed", "Completado"],
  ["warranty", "Warranty", "Garantía"],
];
const OTHER = [
  ["draft", "Draft", "Borrador"],
  ["sent", "Sent", "Enviado"],
  ["lost", "Lost", "Perdido"],
  ["pending_signature", "Waiting for signature", "Esperando firma"],
  ["signed", "Signed", "Firmado"],
  ["pending", "Pending", "Pendiente"],
  ["rejected", "Rejected", "Rechazado"],
  ["skipped", "Skipped", "Omitido"],
  ["customer_responded", "Customer responded", "Cliente respondió"],
  ["closed_approved", "Approved", "Aprobado"],
  ["closed_lost", "Lost", "Perdido"],
  ["prepared_no_provider", "Prepared (no provider)", "Preparado (sin proveedor)"],
  ["queued", "Queued", "En cola"],
  ["logged", "Logged", "Registrado"],
  ["owner", "Owner / Admin", "Dueño / Admin"],
  ["office", "Office", "Oficina"],
  ["crew", "Crew", "Equipo"],
];
const ALL = [...STAGES, ...APPT_TYPES, ...APPT_STATUSES, ...PROJECT_STATUSES, ...OTHER];
export const label = (key, lang) => {
  const f = ALL.find((x) => x[0] === key);
  return f ? f[lang === "es" ? 2 : 1] : key || "";
};

const GREEN = ["approved", "signed", "completed", "contract_signed", "closed_approved", "confirmed"];
const RED = ["needs_attention", "lost", "closed_lost", "cancelled", "no_show", "rejected"];
const BLUE = ["in_progress", "scheduled", "appointment_scheduled", "sent", "estimate_sent"];
const AMBER = ["pending", "pending_signature", "waiting", "waiting_customer", "contract_pending", "estimate_needed", "new_lead", "draft", "prepared_no_provider"];
export const statusColor = (s) =>
  GREEN.includes(s)
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : RED.includes(s)
    ? "bg-red-50 text-red-700 border-red-200"
    : BLUE.includes(s)
    ? "bg-blue-50 text-blue-700 border-blue-200"
    : AMBER.includes(s)
    ? "bg-amber-50 text-amber-700 border-amber-200"
    : "bg-slate-100 text-slate-700 border-slate-200";

export const COMM_TYPES = [
  ["sms", "SMS", "SMS"],
  ["email", "Email", "Correo"],
  ["call", "Phone call", "Llamada"],
  ["note", "Internal note", "Nota interna"],
  ["ai_followup", "AI follow-up", "Seguimiento IA"],
  ["reminder", "Appointment reminder", "Recordatorio"],
  ["review_request", "Review request", "Solicitud de reseña"],
  ["lead", "Lead received", "Prospecto recibido"],
];
export const commLabel = (k, lang) => (COMM_TYPES.find((x) => x[0] === k) || [k, k, k])[lang === "es" ? 2 : 1];
